import { useQuery } from '@tanstack/react-query'
import { useDebounce } from '@uidotdev/usehooks'
import { useState } from 'react'

import { DELAY } from '@/constants'
import {
  type ColumnSort,
  getColumnSortOrder,
  getNextColumnSort,
} from '@/utils/table/columnSort'

import { contractsQueries } from '../api/contractsQueries'
import {
  INITIAL_CONTRACTS_FILTERS,
  toContractsFilterParams,
} from '../lib/contractsListParams'
import type {
  ContractsFilters,
  ContractsSortField,
} from '../types/contracts.types'

export const useContractsList = (organisationId: string) => {
  const [filters, setFilters] = useState<ContractsFilters>(
    INITIAL_CONTRACTS_FILTERS
  )
  const [sort, setSort] = useState<ColumnSort<ContractsSortField>>(null)
  const debouncedDescription = useDebounce(filters.description, DELAY)
  const debouncedNumber = useDebounce(filters.number, DELAY)

  const filterParams = toContractsFilterParams(
    { description: debouncedDescription, number: debouncedNumber },
    sort
  )
  const contractsQuery = useQuery(
    contractsQueries.list(organisationId, filterParams)
  )

  return {
    filters,
    setFilters,
    getSortOrder: (field: ContractsSortField) =>
      getColumnSortOrder(sort, field),
    toggleSort: (field: ContractsSortField) =>
      setSort(getNextColumnSort(sort, field)),
    contractsQuery,
  }
}
